import React, { useState } from 'react';
import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Button,
} from '@fluentui/react-components';
import { CalendarCheckmarkCenterRegular, ChevronDownRegular } from '@fluentui/react-icons';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import ProcessInstanceList from '../processes/ProcessList';
import {
  bodyContentContainer,
  bodyContentWrapper,
} from '../../../app/common/styles/CommonStyleObjects';
import BodyHeaderWithCommandBar from '../../common/headers/BodyHeaderWithCommandBar';
import processCurrentDropdownProps from './CompanyDetail.config';
import PROCESS_LIST_QUERY from '../../../utils/statApi/ProcessApi';
import ProcessStatus from '../../../utils/types/ProcessStatus';
import BackButton from '../../common/BackButton';
import LoadingErrorMessage from '../../common/errorContent/LoadingErrorMessage';
import { IProcessTypeParams } from '../../common/ParamTypes';

const CompanyDetailProcessesInstanceList = (): JSX.Element => {
  const { companyCode, processTypeUri } = useParams<IProcessTypeParams>();
  const [filterStatusKey, setFilterStatusKey] = useState(ProcessStatus.Active);
  const { loading, data, error, refetch } = useQuery(PROCESS_LIST_QUERY, {
    variables: { companyCode, processTypeUri, status: filterStatusKey },
    fetchPolicy: 'cache-and-network',
  });

  const getBodyHeaderTitle = (): JSX.Element => {
    return (
      <>
        <LoadingErrorMessage
          loading={loading}
          error={error}
          actionName="loading the process type data"
        />
        {data && (
          <BackButton ariaLabel="Back to Process Types List">
            <h2>{`Processes for ${data.processList?.name}`}</h2>
          </BackButton>
        )}
      </>
    );
  };

  const onFilterUpdate = (statusString: ProcessStatus): void => {
    refetch({
      companyCode,
      processTypeUri,
      status: statusString,
    });
    setFilterStatusKey(statusString);
  };

  const { processList } = data || { processList: { processes: [] } };

  return (
    <div className={`${bodyContentContainer}  ms-depth-4`}>
      <div className={bodyContentWrapper}>
        <BodyHeaderWithCommandBar title={getBodyHeaderTitle}>
          <Menu>
            <MenuTrigger disableButtonEnhancement>
              <Button
                icon={<CalendarCheckmarkCenterRegular />}
                appearance="subtle"
                aria-label={`${filterStatusKey} Processes, select option to filter by status`}
              >
                {`${filterStatusKey} Processes`} <ChevronDownRegular />
              </Button>
            </MenuTrigger>
            <MenuPopover>
              <MenuList>
                {processCurrentDropdownProps(onFilterUpdate).map((item) => (
                  <MenuItem key={item.key} onClick={item.onClick}>
                    {item.icon}
                    {item.text}
                  </MenuItem>
                ))}
              </MenuList>
            </MenuPopover>
          </Menu>
        </BodyHeaderWithCommandBar>
      </div>
      <ProcessInstanceList
        loading={loading}
        error={error}
        processInstances={processList?.processes}
        processListName={processList?.name}
      />
    </div>
  );
};
export default CompanyDetailProcessesInstanceList;
